import { render, staticRenderFns } from "./InvoiceAlert.vue?vue&type=template&id=3f9765b3&scoped=true"
import script from "./InvoiceAlert.vue?vue&type=script&lang=js"
export * from "./InvoiceAlert.vue?vue&type=script&lang=js"
import style0 from "./InvoiceAlert.vue?vue&type=style&index=0&id=3f9765b3&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9765b3",
  null
  
)

export default component.exports